export const lumConfig :any = {
  debounce: {
    search: 1000,
  },
  decimalPlaces: 2,
  imageFileSizeLimit: 2048000,
};
